<script>
	import { fade } from 'svelte/transition'; // Import the fade transition from Svelte

	let logo = "/logo-full.png"; // Placeholder logo

	// Component props
	export let src; // Image source
	export let alt = ""; // Alt text
	export let threshold = 0; // Optional threshold for lazy loading

	// Reactive variable to manage current src (for transitions)
	let currentSrc = logo; // Start with placeholder

	// Whenever the src changes, we fade between the logo and the actual image
	$: if (src) {
		currentSrc = src; // Change image source when src updates
	}
</script>


<div class="image-container" transition:fade>
	<img
		src={currentSrc}
		alt={alt}
		loading="lazy"
	/>
</div>

<style>
	.image-container {
		position: relative;
		overflow: hidden;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	img {
		max-width: 100%;
		height: auto;
	}
</style>
